/**
 * Rascunho local dos formulários de criação (por tipo de solicitação).
 *
 * Persiste em localStorage com debounce (~800ms). As FOTOS ficam de fora
 * do rascunho: dataURLs de várias peças estouram fácil a cota de ~5MB do
 * localStorage e derrubariam o autosave inteiro — o restante do form vale
 * muito mais do que as fotos, que o colaborador tira de novo em segundos.
 *
 * MT-4.7: rascunho é dado operacional persistente — gravado via
 * tenantStorage (chave prefixada pelo tenant) para o rascunho de um
 * tenant não aparecer para outro login no mesmo navegador.
 */
import { useEffect, useRef } from "react";

import {
  getItemTenant,
  removeItemTenant,
  setItemTenant,
} from "../../../utils/tenantStorage";

const PREFIXO_CHAVE = "pharuerp:solicitacoes:rascunho:";
const DEBOUNCE_MS = 800;

function chave(tipo) {
  return `${PREFIXO_CHAVE}${tipo}`;
}

export function carregarRascunho(tipo) {
  try {
    const bruto = getItemTenant(chave(tipo));
    return bruto ? JSON.parse(bruto) : null;
  } catch {
    return null;
  }
}

export function limparRascunho(tipo) {
  removeItemTenant(chave(tipo));
}

function semFotos(dados) {
  const copia = { ...dados };
  if (Array.isArray(copia.pecas)) {
    copia.pecas = copia.pecas.map((p) => ({ ...p, fotos: [] }));
  }
  if (Array.isArray(copia.fotos)) copia.fotos = [];
  return copia;
}

/**
 * Autosave com debounce. Só grava depois que `ativo` vira true (primeira
 * interação do usuário) — evita persistir o form pristino e fazer o banner
 * de rascunho aparecer para sempre.
 */
export function useAutosaveRascunho(tipo, dados, ativo) {
  const dadosRef = useRef(dados);
  dadosRef.current = dados;

  useEffect(() => {
    if (!ativo) return undefined;
    const timer = setTimeout(() => {
      // setItemTenant já engole cota excedida / storage bloqueado —
      // rascunho é best-effort.
      setItemTenant(chave(tipo), JSON.stringify(semFotos(dadosRef.current)));
    }, DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [tipo, dados, ativo]);
}
